import { Input } from '@/common/components/Input.tsx'
import { useState } from 'react'
import { WizardBodyContainer } from '@/app/pages/program_applications/vendor_application/components/WizardBodyContainer.tsx'
import { WizardFooter } from '@/app/pages/program_applications/vendor_application/components/WizardFooter.tsx'
import { WizardStepTitle } from '@/app/pages/program_applications/vendor_application/components/WizardStepTitle.tsx'
import { WizardStepContent } from '@/app/pages/program_applications/vendor_application/components/WizardStepContent.tsx'
import AlertWithAccent from '@/common/components/AlertWithAccent.tsx'
import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import { useTranslation } from 'react-i18next'

const StepId = 5 as const
export default function ConsentReview() {
  const { t: translate } = useTranslation()
  const { setStepCompleted, goNext } = useWizardContext()
  const [isAttested, setIsAttested] = useState(false)
  const validateForm = () => {
    setStepCompleted(StepId)
    goNext()
  }
  return (
    <>
      <WizardBodyContainer>
        <WizardStepTitle>
          {translate('consent_and_attestation')}
        </WizardStepTitle>
        <WizardStepContent>
          <div className="pb-8 sm:px-20">
            <div className="flex flex-col gap-y-2">
              <div className="flex items-center gap-x-3">
                <Input
                  id="communication-consent"
                  name="communication-consent"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                  required
                />
                <label
                  htmlFor="communication-consent"
                  className="block leading-6 font-medium"
                >
                  {translate('communication_consent')}{' '}
                  <span className="text-danger ml-1">*</span>
                </label>
              </div>
              <p className="ml-8  max-w-2xl">
                {translate('acknowledge_that_text')}
              </p>
            </div>
            <div className=" flex flex-col gap-y-2 py-4">
              <div className="flex items-center gap-x-3">
                <Input
                  id="attestation"
                  name="attestation"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                  required
                />
                <label
                  htmlFor="attestation"
                  className="block leading-6 font-medium"
                >
                  {translate('tos_attestation')}{' '}
                  <span className="text-danger ml-1">*</span>
                </label>
              </div>
              <p className="ml-8 max-w-2xl">
                {translate('i_have_read_and_agree_to_all_of_the')}&nbsp;
                <a
                  className="text-primary font-medium"
                  href="https://drive.google.com/file/d/1StUIPfpsHeLHJnF6TJfTW5r34MqpghAC/view?"
                  target="_blank"
                >
                  {translate('conditions_and_requirements')}&nbsp;
                </a>
                {translate('and_a_attest')}
              </p>
            </div>
            <div className="h-px border-t-2 pt-4" />
            <div className="flex flex-col gap-4">
              <div className="flex flex-row">
                <input
                  id="attestation"
                  name="attestation"
                  type="checkbox"
                  onChange={() => setIsAttested(!isAttested)}
                  required
                  className="h-4 w-4 rounded border-gray-600 text-primary-600 focus:ring-primary-600 mt-1"
                />
                <span className="font-semibold pl-4"> Attestation </span>{' '}
                <span className="text-danger ml-1">*</span>
              </div>
              <p className="ml-8">
                {' '}
                {translate('by_selecting_the')}
                <AlertWithAccent>
                  <span>{translate('disclaimer_text')}</span>
                </AlertWithAccent>{' '}
              </p>
              <div className="flex flex-row py-4">
                <input
                  id="attestation"
                  name="attestation"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-600 text-primary-600 focus:ring-primary-600 mt-1"
                />
                <span className="font-semibold pl-4">
                  {' '}
                  {translate('send_me_a_copy_of_my_responses')}{' '}
                </span>
              </div>
            </div>
          </div>
        </WizardStepContent>
      </WizardBodyContainer>
      <WizardFooter nextButtonText="Submit" onNext={validateForm} />
    </>
  )
}
